module.exports = __webpack_public_path__ + "img/49.052e7513.jpg";